import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import PostCard from '../Layout/PostCard';
import '../../style/Blog.css';

const PublicProfile = () => {
  const { username } = useParams();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch(`https://blog-app-2-v2of.onrender.com/blogs/publicProfile/${username}`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Failed to fetch profile");
        setBlogs(data.blogs);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [username]);

  const filteredBlogs = blogs
    .filter(blog => blog.title.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));

  const authorName = blogs[0]?.author?.username || username;

  if (loading) return <div className="text-center mt-5"><Spinner animation="border" /></div>;
  if (error) return (
    <Container className="text-center mt-5">
      <Alert variant="danger">{error}</Alert>
      <Link to="/" className="retro-button mt-3">Go Home</Link>
    </Container>
  );

  return (
    <Container className="mt-5 mb-4">
      <div className="retro-window mb-5">
        <div className="window-dots">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <h1 className="text-center mb-4">Posts by {authorName}</h1>
        <div className="mb-3 text-center">
          <input
            type="text"
            className="form-control w-75 mx-auto"
            placeholder="Search by title..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <Row className="justify-content-center g-4">
        {filteredBlogs.length === 0 ? (
          <Col xs={12} className="text-center"><p>No posts yet.</p></Col>
        ) : (
          filteredBlogs.map(blog => (
            <Col key={blog._id} xs={12} md={6} lg={4}>
              <PostCard post={blog} />
            </Col>
          ))
        )}
      </Row>
    </Container>
  );
};

export default PublicProfile;
